// extracted by mini-css-extract-plugin
export default {"body":"Home_body__WsMFk"};